import { Logger, LoggerTypes } from '../../utils'

export const SET_FLOW_GROUP_ATTRIBUTE_TAB = 'SET_FLOW_GROUP_ATTRIBUTE_TAB'

export const setFlowGroupAttributeTab = (elementId, element) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowGroupElementsActions.setFlowGroupAttributeTab()', {
    elementId,
    element
  })
  return dispatch({
    type: SET_FLOW_GROUP_ATTRIBUTE_TAB,
    data: { elementId, element }
  })
}
